import "../../styles/physio.css";
import EarthImg from "../../images/Earth-2--Streamline-Ultimate.png";
import MedalImg from "../../images/Award-Medal-1--Streamline-Ultimate.png";
import DealImg from "../../images/Business-Deal-Handshake-1--Streamline-Ultimate.png";
import SubmitImg from "../../images/Drawer-Upload--Streamline-Ultimate.png";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { physiosPageContent } from "../../data/physiosPageContent";
import img1 from "../../images/sinitta-leunen-ZF__96bUIpo-unsplash.jpg";
export default function ContributeDatabase() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  const perks = [
    {
      icon: SubmitImg,
      title: t.contributeDb.PERKS.t1,
      desc: t.contributeDb.PERKS.desc1,
    },
    {
      icon: DealImg,
      title: t.contributeDb.PERKS.t2,
      desc: t.contributeDb.PERKS.desc2,
    },
    {
      icon: MedalImg,
      title: t.contributeDb.PERKS.t3,
      desc: t.contributeDb.PERKS.desc3,
    },
    {
      icon: EarthImg,
      title: t.contributeDb.PERKS.t4,
      desc: t.contributeDb.PERKS.desc4,
    },
  ];

  return (
    <section id="contribute" className="physio-section physio-contribute">
      <div className="glass-card">
        <div className="contribute-layout">
          <div className="contribute-body">
            <span className="physio-eyebrow">{t.contributeDb.s}</span>
            <h2>{t.contributeDb.header}</h2>
            <div className="physio-divider" />
            <p className="section-lead">
              {t.contributeDb.desc}
            </p>

            <div className="contribute-perks">
              {perks.map(({ icon, title, desc }, i) => (
                <div className="perk-row" key={i}>
                  <div className="perk-icon" aria-hidden="true" style={{marginTop: "15px"}}><img src={icon} style={{maxWidth: "26px"}}/></div>
                  <div className="perk-text">
                    <h4>{title}</h4>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="contribute-img">
            <img
              src={img1}
              alt="Image by Sinitta Leunen"
              width="800"
              height="280"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
